// extracted by mini-css-extract-plugin
export default {"loader_container":"bootstrap_loader_container__obfJf"};